import React from "react";
import moment from "moment";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import EtatMachineCell from "./EtatMachineCell";
import { getConsommationAffichee } from "./motorHelpers";

export default function MotorCard({
  motor,
  index,
  isExpanded,
  onToggleExpand,
  onClick,
  onDelete,
  isAdmin,
  errorMessage,
  maintenanceState,
  dureeFctMap,
  consoMap,
}) {
  const conso = getConsommationAffichee(motor, consoMap);
  const maintenanceColor =
    maintenanceState === "A faire"
      ? "bg-red-200 text-red-700"
      : maintenanceState === "A prévoir"
      ? "bg-orange-200 text-orange-700"
      : "bg-green-200 text-green-700";

  return (
    <div
      className={`flex flex-col mb-10 rounded-lg shadow-md border border-bleuSTB mt-5 ${
        errorMessage ? "bg-red-200" : ""
      }`}
      onClick={onClick}
      title={errorMessage}
    >
      {/* En-tête */}
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center">
          <span className="text-sm md:text-2xl text-bleuSTB font-bold">
            {motor.nom_moteur}
          </span>
          <button
            type="button"
            className="ml-2 text-bleuSTB"
            onClick={(e) => {
              e.stopPropagation();
              onToggleExpand(index);
            }}
          >
            {isExpanded ? (
              <FaChevronUp className="ml-4" />
            ) : (
              <FaChevronDown className="ml-4" />
            )}
          </button>
        </div>
        {isAdmin && (
          <div className="text-xs md:text-base text-end ml-6">
            Client : {motor.client}
          </div>
        )}
      </div>

      {/* Détails expandés */}
      {isExpanded && (
        <div className="p-4 space-y-2">
          <div>
            <span className="font-bold text-xs md:text-xl text-bleuSTB">
              Date de mise en service :
            </span>{" "}
            <span className="text-xs md:text-base ml-1">
              {moment(motor.dateMiseEnService).format("DD/MM/YYYY")}
            </span>
          </div>
          <div>
            <span className="font-bold text-xs md:text-xl text-bleuSTB">
              Localisation :
            </span>{" "}
            <span className="text-xs ml-1 md:text-base">{motor.localisation}</span>
          </div>
          <div>
            <span className="font-bold text-xs md:text-xl text-bleuSTB">
              Consommation :
            </span>{" "}
            <span className="text-xs ml-1 md:text-base whitespace-nowrap">{conso} kWh</span>
          </div>
          <div>
            <span className="font-bold text-xs md:text-xl text-bleuSTB">
              DureeFct :
            </span>{" "}
            <span className="text-xs ml-1 md:text-base whitespace-nowrap">
              {parseInt(dureeFctMap[motor._id]?.toFixed(0))} h
            </span>
          </div>

          <div className={`text-xs md:text-base rounded-md px-2 py-1 ${maintenanceColor}`}>
            <span className="font-semibold">Maintenance :</span> {maintenanceState}
          </div>

          <div
            className={`text-xs mt-2 md:text-base rounded-md px-2 py-1 ${
              motor.etatVibratoire.length > 0
                ? "bg-red-200 text-red-700"
                : "bg-green-200 text-green-700"
            }`}
          >
            <span className="font-semibold">Etat de la machine :</span>
            <div className="mb-2" />
            <EtatMachineCell motor={motor} />
          </div>

          <div className="flex justify-end mt-4">
            <button
              className="bg-red-600 hover:bg-red-700 text-white text-base px-4 py-2 rounded-md"
              onClick={(e) => {
                e.stopPropagation();
                onDelete(motor._id);
              }}
            >
              Supprimer
            </button>
          </div>
        </div>
      )}
    </div>
  );
}